<template>
  <v-card class="mt-8 pb-4">
    <v-card-title>預約資料</v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          class="col-auto"
          v-for="key in [
            '日期',
            '地點',
            '建議時間',
            '開始時間',
            '結束時間',
            '預約時間',
          ]"
          :key="key"
          cols="12"
          md="2"
        >
          <template v-if="key == '預約時間'">
            <v-text-field
              label="預約時間"
              :value="預約時間"
              outlined
              dense
              hide-details
              disabled
            >
            </v-text-field>
          </template>
          <template v-else-if="key == '建議時間'">
            <v-text-field
              label="建議報到時間"
              :value="person[key]"
              outlined
              dense
              hide-details
              disabled
            >
            </v-text-field>
          </template>
          <template v-else>
            <v-text-field
              :label="key"
              :value="person[key]"
              outlined
              dense
              hide-details
              disabled
            >
            </v-text-field>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-auto" cols="12">
          今年尚可做的篩檢項目：{{ 篩檢項目 }}
          <br />
          <a :href="surveyURL" target="_blank" rel="noopener">
            <template v-if="person.外部問卷"> 已填寫問卷 </template>
            <template v-else> 未填寫問卷 </template>
          </a>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn large class="px-8 mx-2" color="error" @click="cancel"
        >取消預約</v-btn
      >
      <v-dialog v-model="dialog" persistent max-width="400">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            large
            class="px-8 mx-2"
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <template> 修改預約 </template>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>預約時段</v-card-title>
          <v-card-text class="mt-2 pb-0">
            <reserveSection
              v-if="dialog"
              v-model="section"
              :selectedPerson="person"
            ></reserveSection>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false"> 取消 </v-btn>
            <v-btn color="primary" text @click="reserve"> 預約 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import _ from "lodash";
import reserveSection from "@/components/People/reserveSection.vue";
import { surveyURL } from "@/../env.js";
export default {
  name: "Reserve",
  props: ["person"],
  components: { reserveSection },
  data: () => ({
    dialog: false,
    section: null,
    //
  }),
  computed: {
    surveyURL() {
      return `${surveyURL}?aka_name=${this.person.姓名}&aka_id=${this.person.身分證字號}`;
    },
    篩檢項目() {
      return Object.keys(_.pickBy(this.person.篩檢項目, (o) => o)).join("、");
    },
    預約時間() {
      return dayjs(this.person.createdAt).format("MM/DD HH:mm");
    },
  },
  methods: {
    async reserve() {
      try {
        await this.axios.post("/dashboard/person/reserve", {
          person: this.person,
          section: this.section,
        });
        this.dialog = false;
        this.$toast.success("預約成功");
        this.$emit("load");
      } catch (e) {
        this.$toast.error("預約失敗");
      }
    },
    async cancel() {
      if (confirm("確定取消預約？")) {
        try {
          await this.axios.post("/dashboard/person/cancel", {
            person: this.person,
          });
          this.$toast.success("取消成功");
          this.$emit("load");
        } catch (e) {
          this.$toast.error("取消失敗");
        }
      }
    },
  },
};
</script>
